import { render, staticRenderFns } from "./AlertasBase.vue?vue&type=template&id=a07e3206&"
import script from "./AlertasBase.vue?vue&type=script&lang=ts&"
export * from "./AlertasBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a07e3206', component.options)
    } else {
      api.reload('a07e3206', component.options)
    }
    module.hot.accept("./AlertasBase.vue?vue&type=template&id=a07e3206&", function () {
      api.rerender('a07e3206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarBase/AlertasBase.vue"
export default component.exports